export const getCaseById = (listOfCases, id) => listOfCases.find(
	(cas) => cas.id == id,
);

export const getContactById = (contactList, id) => contactList.find(
	(contact) => contact.idCase == id
);

export const getDocumentstById = (documentList, id) => documentList.find(
	(document) => document.idCase == id
);